import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import { paths } from '@/routes/paths';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <AppShell hideTabs>
      <PageContainer>
        <EmptyState
          icon="404"
          title={t('errors.not_found')}
          action={
            <Button block onClick={() => navigate(paths.home, { replace: true })}>
              {t('nav.home')}
            </Button>
          }
        />
      </PageContainer>
    </AppShell>
  );
}
